import React, { useContext } from "react";
import "./SelectRamlComp2.css";
import { SelectRamlContext } from "../../contexts/SelectRamContext";
export default function SelectRamlComp2() {
  const ramlContext = useContext(SelectRamlContext);

  if (ramlContext.resobj.length > 3) {
    let mainObj2 = {
      Value:
        "" + `${ramlContext.resobj[0][0].keyA}` + "" + `${ramlContext.resobj[1][0].keyA}` + "" + `${ramlContext.resobj[2][0].keyA}` + "" + `${ramlContext.resobj[3][0].keyA}` + "",
    };
    localStorage.setItem("mainObj2", JSON.stringify(mainObj2));
  }

  return (
    <div className="container selramcom-container">
      <div className="row">
        <div className="col mt-5 selramcom-col centerrc">
          <div className="selramcom-col-div displayon centerr">
            {ramlContext.resobj.length != 0 &&
              ramlContext.resobj.map((item, index) => (
                <div key={index} className="selramcom-div2">
                  <img className="selramcom-img" src={item[0].src} alt="" />
                </div>
              ))}

            <div className={ramlContext.resobj.length < 1 ? "selramcom-div22" : "selramcom-div2 hide"}> شکل یک</div>
            <div className={ramlContext.resobj.length < 2 ? "selramcom-div22" : "selramcom-div2 hide"}>شکل دو</div>
            <div className={ramlContext.resobj.length < 3 ? "selramcom-div22" : "selramcom-div2 hide"}>شکل سه</div>
            <div className={ramlContext.resobj.length < 4 ? "selramcom-div22" : "selramcom-div2 hide"}>شکل چهار</div>
          </div>
        </div>
      </div>
    </div>
  );
}
